import { Injectable } from '@angular/core';
import { SwUpdate, type VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PromptUpdateService {
    constructor(swUpdate: SwUpdate) {
        swUpdate.versionUpdates.pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')).subscribe(() => {
            // TODO: Possibly more user friendly to show a snackbar/prompt to the user instead of just reloading the page.
            // Though risky, the user can work with an outdated version of the app if they ignore the prompt, which can lead to bugs and issues.
            this.reloadPage();
        });
    }

    /**
     * Reloads the current page by refreshing the document location.
     * This method forces the browser to reload the current document from the server.
     *
     * Seperate function so we can spy on it in tests.
     */
    /* istanbul ignore next */
    reloadPage() {
        document.location.reload();
    }
}
